import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  searchRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2),
  },
  searchInput: {
    width: '100%',
    backgroundColor: theme.palette.white,

    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(40),
    },
  },
}))

export default useStyles
